"use strict";

define('libs/table.group.helper',['underscore', 'backbone', 'marionette', 'handlebars', 'uikit/uikit'], function (_, Backbone, Mn, Handlebars, UIKit) {
  var TableView = UIKit.Table;
  function TableGroupHelper(srcCollection) {
    this.src = srcCollection;
    this.dest = new Backbone.Collection([]);
    this.processors = {
      text: _.identity,
      sort: _.identity,
      key: function key() {
        throw new Error('You must define a key processor.');
      }
    };
    _.each(this.processors, function (fn, key) {
      this[key] = function (fn) {
        this.processors[key] = fn;
        return this;
      };
    }, this);
    this.key = function (fn) {
      this.processors.key = _.isFunction(fn) ? fn : function (model) {
        return model.get(fn);
      };
      return this;
    };
    this.listenTo(srcCollection, 'add remove reset sort', _.debounce(function () {
      this.processSrc();
    }));
  }
  ;
  _.extend(TableGroupHelper.prototype, Backbone.Events);
  TableGroupHelper.prototype.collection = function () {
    return this.dest;
  };
  TableGroupHelper.prototype.processSrc = function () {
    var groups = [],
      index = {},
      items = [];
    this.src.each(function (model, i, collection) {
      var groupKey = this.processors.key.call(this, model, i, collection);
      if (!index[groupKey]) {
        groups.push(this.createGroupModel(groupKey));
        index[groupKey] = [];
      }
      index[groupKey].push(model);
    }, this);
    var sortedGroups = this.processors.sort(groups);
    _.each(sortedGroups, function (groupModel, i) {
      var models = index[groupModel.get('key')];
      items.push(groupModel);
      items = items.concat(models);
      if (i === 0) {
        this.trigger('first:model', this, _.first(models));
      } else if (i === sortedGroups.length - 1) {
        this.trigger('last:model', this, _.last(models));
      }
    }, this);
    this.dest.set(items);
    this.dest.trigger('sync', this.dest, [], {});
    this.trigger('groups', this, sortedGroups);
    return this;
  };
  TableGroupHelper.prototype.createGroupModel = function (groupKey) {
    return new TableView.RowHeaderModel({
      text: this.processors.text(groupKey),
      key: groupKey
    });
  };
  TableGroupHelper.sortByText = function (direction) {
    var reverse = false;
    direction = String(direction || '').toLowerCase();
    if (direction === 'DESC') {
      reverse = true;
    }
    return function (groups) {
      var sorted = _.sortBy(groups, function (group) {
        return String(group.get('text') || '').toLowerCase();
      });
      if (reverse) {
        sorted.reverse();
      }
      return sorted;
    };
  };
  return TableGroupHelper;
});

